import { extensionsType } from '@pages/organizer/Cloud/const/extensions-type';
import { getUrl } from '@pages/organizer/Cloud/utils/get-url-from-icons';

import type { DetailInfoType, FileType } from '@pages/organizer/Cloud/store/cloud-store/cloud-types';
import type { Nullable } from '@shared/types/base-custom.type';

export const detailsFileData = (data: FileType, ownerID: number): Nullable<DetailInfoType> => {
  const { file } = data || {};
  if (!data) return null;

  const galleryUrl = getUrl(file.icons, 'gallery');

  return {
    name: file.name,
    size: file.size,
    url: galleryUrl ?? '',
    type: file.extension,
    formatter_type: extensionsType[file.extension] || '',
    created_at: file.created_at,
    location: '',
    item: '',
    hub: null,
    is_system: false,
    owner_id: ownerID,
    ownerName: 'Me',
    id: data.id,
    hub_name: null,
  };
};
